import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'

@InputType()
export class GetShipEngineFormDownloadArgs extends ActionArgs {
  @Field(() => String)
  labelId: string
}

export interface IGetShipEngineFormDownload extends IAction<string | undefined, GetShipEngineFormDownloadArgs> {}
